import { ApolloProvider } from 'core/net/ApolloProvider';
import { NoiseEventClassification } from './noiseService.types';
import { UPDATE_CLASSIFICATION } from './graphql/facility.updateClassification';
import { UpdateClassificationMutation, UpdateClassificationMutationVariables } from 'app/__generated__/global';

export const editNoiseEventClassification = async (
  classification: NoiseEventClassification
): Promise<NoiseEventClassification> => {
  const { utcDeletedAt: _, ...updateFields } = classification; // remove utcDeletedAt property if present
  const { data, error } = await ApolloProvider.global().mutate<
    UpdateClassificationMutation,
    UpdateClassificationMutationVariables
  >({
    mutation: UPDATE_CLASSIFICATION,
    variables: {
      input: {
        ...updateFields,
      },
    },
  });
  if (!data || error) throw new Error(`Something went wrong when trying edit classification: ${error}`);
  const {
    facility: {
      classification: { updateClassification },
    },
  } = data;
  if (!updateClassification) throw new Error(`No classification returned for: ${classification.name}`);
  const { categoryId, id, name, utcDeactivatedAt, utcDeletedAt, disregardEvents } = updateClassification;
  return {
    categoryId,
    id,
    name,
    utcDeactivatedAt: utcDeactivatedAt ?? null,
    utcDeletedAt: utcDeletedAt ?? null,
    disregardEvents,
  };
};
